import React, { useState } from 'react';
import { Modal, Button, TextField, Grid } from '@mui/material';
import { useUser } from '../contexts/UserContext';

function CantidadModal({ open, handleClose }) {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const { user } = useUser();

  const [descripcionCantidad, setDescripcionCantidad] = useState('');
  const [fechaIngreso, setFechaIngreso] = useState(new Date().toISOString().split('T')[0]); // Fecha actual
  const [modificacion, setModificacion] = useState(1); // Valor predeterminado

  const handleGuardarCantidad = async () => {
    // Debug: verificar qué usuario está llegando
    console.log('Usuario del contexto:', user);
    console.log('Código de usuario:', user?.codigoUsuario);
    
    // Intentar diferentes posibles nombres de campo para el código de usuario
    const codigoUsuario = user?.codigoUsuario || user?.codUsuario || user?.codigo || user?.username || 'ADMIN';
    
    // Prepara los datos para el POST
    const ingresadoPorCompleto = codigoUsuario.toString().padEnd(20, ' ').substring(0, 20);
    
    console.log('Usuario final a enviar:', ingresadoPorCompleto);
    
    const nuevaCantidad = {
      IdCantidad: 0, // Nuevo registro
      DescripcionCantidad: descripcionCantidad, // Cambiado el nombre del campo
      IngresadoPor: ingresadoPorCompleto, // Usuario con exactamente 20 caracteres
      FechaIngreso: fechaIngreso,
      Modificacion: modificacion,
    };

    console.log('Payload a enviar:', JSON.stringify(nuevaCantidad, null, 2));

    try {
      // Realizar la solicitud POST
      const response = await fetch(`${server}/CdmCantidades`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(nuevaCantidad),
      });

      if (response.ok) {
        const data = await response.json();
        alert('Cantidad guardada correctamente');
        console.log('Datos guardados:', data);
      } else {
        alert('Error al guardar la cantidad');
        console.error('Error al guardar la cantidad:', response.statusText);
      }
    } catch (error) {
      alert('Error al conectarse con el servidor');
      console.error('Error en la solicitud POST:', error);
    }

    // Cierra el modal después de guardar
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div style={{ padding: '20px', background: 'white', margin: '50px auto', maxWidth: '500px' }}>
        <h2>Agregar Cantidad</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Descripción de la Utilidad"
              value={descripcionCantidad}
              onChange={(e) => setDescripcionCantidad(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button onClick={handleGuardarCantidad} variant="contained" color="primary">
              Guardar
            </Button>
            <Button onClick={handleClose} variant="outlined" color="secondary" style={{ marginLeft: '10px' }}>
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

export default CantidadModal;
